<template>
  <div>
       <div class="Loc MobileHide">
       <div>
         <h1 class="leagueNam"><router-link style="color: white !important; margin-top: -80px;" id="routerLink" :to="{ name: 'LeaguePageNav', params: { leagueId: tournId} }">{{MatchStats.match.tournament.name}}</router-link></h1>
           <div class="row" style="margin-top: 70px;">
            <div class="col" style="text-align: center;">
              <router-link id="routerLink" :to="{ name: 'teamPage', params: { id: MatchStats.match.team1.id } }"><img style="width: 110px; margin-top: -80px;" :src="teamLogo + MatchStats.match.team1.id"  /></router-link>
              <p style="color: white;">{{team1name}}</p>
            </div>
            <div class="col" style="text-align: center;">
              <h3 class="mobileScore MobileHide" style="color: white; background: rgba(34, 33, 58,0.5);  margin: 0px 50px 0px 50px;">{{MatchStats.match.currentScore}}</h3>
              <h5 v-if="MatchStats.match.matchStatus.name =='LIVE'" style="color: white; margin-top: 15px;">{{calculateMinutes(MatchStats.match.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute;" alt="'"></h5>
              <h5 v-else-if="MatchStats.match.matchStatus.name =='HT'" style="color: white; margin-top: 15px;">HT</h5>
              <h5 v-else style="color: white; margin-top: 15px;">{{MatchStats.match.matchTime}}</h5>
            </div>
            <div class="col" style="text-align: center;"> 
              <router-link id="routerLink" :to="{ name: 'teamPage', params: { id: MatchStats.match.team2.id} }"><img style="width: 110px; margin-top: -80px;" :src="teamLogo + MatchStats.match.team2.id" /></router-link>
              <p style="color: white;">{{team2name}}</p>
             </div>
            </div>
          </div>
      </div>
      <div class="Loc MobileShow " style="height: 100%; width: 100%;">
          <b-container style="color: white; margin-top: 10px;" class=" bv-example-row bv-example-row-flex-cols">
          <b-row align-v="start">
            <b-col style="text-align: center;"><router-link style="color: white !important; " id="routerLink" :to="{ name: 'LeaguePageNav', params: { leagueId: tournId} }">{{MatchStats.match.tournament.name}}</router-link></b-col>
          </b-row>
          <b-row align-v="center" style="text-align: center;">
            <b-col style=""><router-link style="" id="" :to="{ name: 'teamPage', params: { id: MatchStats.match.team1.id} }"><img  class="" style="width: 60px;" :src="teamLogo + MatchStats.match.team1.id"/></router-link></b-col>
            <b-col style="">
              <h4 class="mobileScore MobileShow" style="">{{MatchStats.match.currentScore}}</h4>
              <p v-if="MatchStats.match.matchStatus.name =='LIVE'" style="font-size: 13px;" >{{calculateMinutes(MatchStats.match.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: 0px;" alt="'"></p>
              <p v-else-if="MatchStats.match.matchStatus.name =='HT'" style="font-size: 13px;" >HT</p>
              <p v-else style="font-size: 13px;">{{MatchStats.match.matchTime}}</p>
            </b-col>
            <b-col><router-link style="" id="" :to="{ name: 'teamPage', params: { id: MatchStats.match.team2.id} }"><img  class="logoImage" style="width: 60px;" :src="teamLogo + MatchStats.match.team2.id"/></router-link> <br></b-col>
          </b-row>
          <b-row style="text-align: center; font-size: 14px;" >
            <b-col>{{MatchStats.match.team1.name}} </b-col>
            <b-col></b-col>
            <b-col>{{MatchStats.match.team2.name}} </b-col>
          </b-row>
        </b-container>
      </div>

    <!-- Tabs -->
<div style="border-radius: 0px; background: #212529;">
  <b-tabs class="Some" style="border-radius: 0px; color: black; background: white;" 
    active-nav-item-class="text-white bg-success" 
    active-tab-class=""
    justified
  >
    <b-tab style="border-radius: 0px;" active>
      <template v-slot:title>
        <img style="width: 23px" src="@/assets/matchpageNavbar/info.png"><br><p style="margin: 0px; color: #333333; font-size: 12px;">{{ $t('LanguageEn.txtInfo') }}</p>
      </template>
            <li class="list-group-item listHeader" style="border-radius: 0px;" v-if="MatchStats.match.events.length == 0 && MatchStats.match.tvStations == 0">There is no data at the moment!</li>
            <li class="list-group-item listHeader" style="border-radius: 0px;" v-else-if="MatchStats.match.events.length == 0 && MatchStats.match.tvStations != 0"><span>Broadcasted at:  </span>  <span v-for="tv in MatchStats.match.tvStations" :key="tv">{{tv}}, </span></li>
          <div v-else> 
          <div v-if="MatchStats.match.events[0]" style="font-size: 12px;" class="MobileHide">
            <li class="list-group-item listHeader" style="border-radius: 0px;">{{ $t('LanguageEn.matchSet1') }}</li>
            <div class="container" v-for="match in summedArray" :key="match.id">
            <div class="row infoItem" style="background: #4d4d4d;  border-bottom: 1px solid #434343; line-height: 1.6;" v-if="parseInt(match.eventTime) <= 45">
                <div class="col" v-bind:class="{ team2: match.team == 'team2'}">
                <span >
              <span v-if="match.team == 'team1'" style="margin-right: 2px; font-weight: bold;">{{parseInt(match.eventTime.slice(0,-3))}}'</span>
              <img style="width: 24px;" src="@/assets/yellowcardBig.png" v-if="match.eventType == 'yellowcard'"/><img style="width: 24px;" src="@/assets/missed.png" v-else-if="match.eventType == 'missed_penalty'"/><img style="width: 24px;" src="@/assets/goalBig.png" v-else-if="match.eventType == 'goal' || match.eventType == 'penalty'"/><img style="width: 24px;" src="@/assets/redCardBig.png" v-else-if="match.eventType == 'redcard'"/><img style="width: 24px;" src="@/assets/yellowred.png" v-else-if="match.eventType == 'yellowred'"/><img v-else-if="match.eventType == 'var'" style="width: 24px;" src="@/assets/varCancel.png"/> <img v-else-if="match.eventType == 'own-goal'" style="width: 24px;" src="@/assets/ownGoal.png"/> <img v-else-if="match.eventType == 'substitution'" style="width: 24px;" src="@/assets/subIn.png"/> <span v-else>{{match.eventType}}</span>
              <span v-if="match.player.commonName">
               <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.player.id} }">
                 {{match.player.commonName}} 
                </router-link>
              </span>
              <span v-if="match.assistant && match.eventType == 'substitution'"> <img style="width: 24px;" src="@/assets/subOut.png"/> <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.assistant.id} }"> {{match.assistant.commonName}} </router-link> </span>
              <span v-if="match.videoPath && match.videoPath != null"><img @click="openPlayer(match.videoPath)" src="@/assets/vid.png" style="width: 24px; cursor: pointer;" alt=""></span> 
              <span v-if="match.team == 'team2'" style="margin-left: 2px; font-weight: bold;">{{parseInt(match.eventTime.slice(0,-3))}}'</span>
                  </span>
                  </div>
            </div>
            </div>
            <!-- <div class="container" v-for="match in summedArray" :key="match.id">
            <div class="row infoItem" style="background: #4d4d4d;  border-bottom: 1px solid #434343; line-height: 1.6; " v-if="parseInt(match.eventTime) <= 45">
                <div class="col" style="text-align: left;" >
                  <span v-if="match.team == 'team1'">
                  <img style="height: 15px;" src="@/assets/yellowcardBig.png" v-if="match.eventType == 'yellowcard'"/><img style="height: 15px;" src="@/assets/missed.png" v-else-if="match.eventType == 'missed_penalty'"/><img style="height: 15px;" src="@/assets/goalBig.png" v-else-if="match.eventType == 'goal' || match.eventType == 'penalty'"/><img style="height: 15px;" src="@/assets/redCardBig.png" v-else-if="match.eventType == 'redcard'"/><img style="height: 15px;" src="@/assets/yellowred.png" v-else-if="match.eventType == 'yellowred'"/><span v-else-if="match.eventType == 'var'"><img style="height: 15px;" src="@/assets/missed.png"/> <sup>var</sup></span> <span v-else-if="match.eventType == 'own-goal'"> <img style="height: 15px;" src="@/assets/goalBig.png"/> <sup style="margin-left: -7px;">OG</sup> </span><span v-else-if="match.eventType == 'substitution'"></span> <span v-else>{{match.eventType}}</span>
              <span v-if="match.player.commonName">
               <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.player.id} }">
                 {{match.player.commonName}} 
                </router-link>
              </span>
              <span v-if="match.assistant && match.eventType == 'substitution'"> <img style="height: 15px; transform: rotate(180deg);" src="@/assets/substitutionBig.png"/> <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.assistant.id} }"> {{match.assistant.commonName}} </router-link> </span>
              <span v-if="match.videoPath && match.videoPath != null"><img @click="openPlayer(match.videoPath)" src="@/assets/vid.png" style="width: 20px; cursor: pointer;" alt=""></span> 
                  </span>
                  </div>
                <div class="col-1" style="text-align: center; font-weight: bold;">{{parseInt(match.eventTime.slice(0,-3))}}'</div>
                <div class="col" style="text-align: right;">
                  <span v-if="match.team == 'team2'">
                    <img style="height: 15px;" src="@/assets/yellowcardBig.png" v-if="match.eventType == 'yellowcard'"/><img style="height: 15px;" src="@/assets/missed.png" v-else-if="match.eventType == 'missed_penalty'"/><img style="height: 15px;" src="@/assets/goalBig.png" v-else-if="match.eventType == 'goal' || match.eventType == 'penalty'"/><img style="height: 15px;" src="@/assets/redCardBig.png" v-else-if="match.eventType == 'redcard'"/><img style="height: 15px;" src="@/assets/yellowred.png" v-else-if="match.eventType == 'yellowred'"/><span v-else-if="match.eventType == 'var'"><img style="height: 15px;" src="@/assets/missed.png"/> <sup>var</sup></span> <span v-else-if="match.eventType == 'own-goal'"> <img style="height: 15px;" src="@/assets/goalBig.png"/> <sup style="margin-left: -7px;">OG</sup> </span><span v-else-if="match.eventType == 'substitution'"></span> <span v-else>{{match.eventType}}</span>
              <span v-if="match.player.commonName">
               <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.player.id} }">
                 {{match.player.commonName}} 
                </router-link>
              </span>
              <span v-if="match.assistant && match.eventType == 'substitution'"> <img style="height: 15px; transform: rotate(180deg);" src="@/assets/substitutionBig.png"/> <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.assistant.id} }"> {{match.assistant.commonName}} </router-link> </span>
              <span v-if="match.videoPath && match.videoPath != null"><img @click="openPlayer(match.videoPath)" src="@/assets/vid.png" style="width: 20px; cursor: pointer;" alt=""></span>  
                  </span>
                </div>
            </div>
            </div> -->
            <li class="list-group-item listHeader" style="border-radius: 0px;">{{ $t('LanguageEn.matchSet2') }}</li>
            <!-- <div class="container" v-for="match in summedArray" :key="match.k">
            <div class="row infoItem" style="background: #4d4d4d;  border-bottom: 1px solid #434343; line-height: 1.6;" v-if="parseInt(match.eventTime) > 45">
                <div class="col" style="text-align: left;" >
                  <span v-if="match.team == 'team1'">
                  <img style="height: 15px;" src="@/assets/yellowcardBig.png" v-if="match.eventType == 'yellowcard'"/><img style="height: 15px;" src="@/assets/missed.png" v-else-if="match.eventType == 'missed_penalty'"/><img style="height: 15px;" src="@/assets/goalBig.png" v-else-if="match.eventType == 'goal' || match.eventType == 'penalty'"/><img style="height: 15px;" src="@/assets/redCardBig.png" v-else-if="match.eventType == 'redcard'"/><img style="height: 15px;" src="@/assets/yellowred.png" v-else-if="match.eventType == 'yellowred'"/><span v-else-if="match.eventType == 'var'"><img style="height: 15px;" src="@/assets/missed.png"/> <sup>var</sup></span> <span v-else-if="match.eventType == 'own-goal'"> <img style="height: 15px;" src="@/assets/goalBig.png"/> <sup style="margin-left: -7px;">OG</sup> </span><span v-else-if="match.eventType == 'substitution'"></span> <span v-else>{{match.eventType}}</span>
              <span v-if="match.player.commonName">
               <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.player.id} }">
                 {{match.player.commonName}} 
                </router-link>
              </span>
              <span v-if="match.assistant && match.eventType == 'substitution'"> <img style="height: 15px; transform: rotate(180deg);" src="@/assets/substitutionBig.png"/> <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.assistant.id} }"> {{match.assistant.commonName}} </router-link> </span>
              <span v-if="match.videoPath && match.videoPath != null"><img @click="openPlayer(match.videoPath)" src="@/assets/vid.png" style="width: 20px; cursor: pointer;" alt=""></span> 
                  </span>
                  </div>
                <div class="col-1" style="text-align: center; font-weight: bold;">{{parseInt(match.eventTime.slice(0,-3))}}'</div>
                <div class="col" style="text-align: right;">
                  <span v-if="match.team == 'team2'">
                    <img style="height: 15px;" src="@/assets/yellowcardBig.png" v-if="match.eventType == 'yellowcard'"/><img style="height: 15px;" src="@/assets/missed.png" v-else-if="match.eventType == 'missed_penalty'"/><img style="height: 15px;" src="@/assets/goalBig.png" v-else-if="match.eventType == 'goal' || match.eventType == 'penalty'"/><img style="height: 15px;" src="@/assets/redCardBig.png" v-else-if="match.eventType == 'redcard'"/><img style="height: 15px;" src="@/assets/yellowred.png" v-else-if="match.eventType == 'yellowred'"/><span v-else-if="match.eventType == 'var'"><img style="height: 15px;" src="@/assets/missed.png"/> <sup>var</sup></span> <span v-else-if="match.eventType == 'own-goal'"> <img style="height: 15px;" src="@/assets/goalBig.png"/> <sup style="margin-left: -7px;">OG</sup> </span><span v-else-if="match.eventType == 'substitution'"></span> <span v-else>{{match.eventType}}</span>
              <span v-if="match.player.commonName">
               <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.player.id} }">
                 {{match.player.commonName}} 
                </router-link>
              </span>
              <span v-if="match.assistant && match.eventType == 'substitution'"> <img style="height: 15px; transform: rotate(180deg);" src="@/assets/substitutionBig.png"/> <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.assistant.id} }"> {{match.assistant.commonName}} </router-link> </span>
              <span v-if="match.videoPath && match.videoPath != null"><img @click="openPlayer(match.videoPath)" src="@/assets/vid.png" style="width: 20px; cursor: pointer;" alt=""></span>  
                  </span>
                </div>
            </div>
            </div> -->
             <div class="container" v-for="match in summedArray" :key="match.k">
            <div class="row infoItem" style="background: #4d4d4d;  border-bottom: 1px solid #434343; line-height: 1.6;" v-if="parseInt(match.eventTime) > 45">
                <div class="col" v-bind:class="{ team2: match.team == 'team2'}">
                  <span>
              <span v-if="match.team == 'team1'" style="margin-right: 2px; font-weight: bold;">{{parseInt(match.eventTime.slice(0,-3))}}'</span>
              <img style="width: 24px;" src="@/assets/yellowcardBig.png" v-if="match.eventType == 'yellowcard'"/><img style="width: 24px;" src="@/assets/missed.png" v-else-if="match.eventType == 'missed_penalty'"/><img style="width: 24px;" src="@/assets/goalBig.png" v-else-if="match.eventType == 'goal' || match.eventType == 'penalty'"/><img style="width: 24px;" src="@/assets/redCardBig.png" v-else-if="match.eventType == 'redcard'"/><img style="width: 24px;" src="@/assets/yellowred.png" v-else-if="match.eventType == 'yellowred'"/><img v-else-if="match.eventType == 'var'" style="width: 24px;" src="@/assets/varCancel.png"/> <img v-else-if="match.eventType == 'own-goal'" style="width: 24px;" src="@/assets/ownGoal.png"/> <img v-else-if="match.eventType == 'substitution'" style="width: 24px;" src="@/assets/subIn.png"/> <span v-else>{{match.eventType}}</span>
              <span v-if="match.player.commonName">
               <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.player.id} }">
                 {{match.player.commonName}} 
                </router-link>
              </span>
              <span v-if="match.assistant && match.eventType == 'substitution'"> <img style="width: 24px;" src="@/assets/subOut.png"/> <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.assistant.id} }"> {{match.assistant.commonName}} </router-link> </span>
              <span v-if="match.videoPath && match.videoPath != null"> <img @click="openPlayer(match.videoPath)" src="@/assets/vid.png" style="width: 24px; cursor: pointer; margin-right: 2px;" alt=""></span> 
              <span v-if="match.team == 'team2'" style="margin-left: 2px; font-weight: bold;">{{parseInt(match.eventTime.slice(0,-3))}}'</span>
                  </span>
                  </div>
            </div>
            </div>
             <div v-if="MatchStats.match.referee && MatchStats.match.venue">
            <li class="list-group-item listHeader" style="border-radius: 0px;">{{ $t('LanguageEn.txtReferee') }} / {{ $t('LanguageEn.txtStadium') }}</li>
            <li class="list-group-item referee" v-if="MatchStats.match.referee.name">{{ $t('LanguageEn.txtReferee') }}: {{MatchStats.match.referee.name}}</li>
            <li class="list-group-item referee" v-if="MatchStats.match.venue.name">{{ $t('LanguageEn.txtStadium') }}: {{MatchStats.match.venue.name}}</li> 
            <li class="list-group-item referee" v-if="MatchStats.match.tvStations.length != 0"> Broadcasted: <span v-if="MatchStats.match.tvStations[0]">{{MatchStats.match.tvStations[0]}},</span> <span v-if="MatchStats.match.tvStations[1]">{{MatchStats.match.tvStations[1]}},</span> <span @click="$refs['tv-modal'].show()" style="text-decoration: underline; cursor: pointer; color: #1a7bfb;"> More</span> </li> 
            <b-modal ref="tv-modal" size="md" hide-footer centered title="TV Stations:">
                <ul style="list-style-type: none;">
                  <li v-for="sing in MatchStats.match.tvStations" :key="sing.id">{{sing}}</li>
                </ul>
            </b-modal>
            </div>
            </div>
    </div>
    <div> 
          <div v-if="MatchStats.match.events[0]" class="MobileShow" style="font-size: 12px;">
            <li class="list-group-item listHeader" style="border-radius: 0px;">{{ $t('LanguageEn.matchSet1') }}</li>
              <div class="container" v-for="match in summedArray" :key="match.kk">
            <div class="row infoItem" style="background: #4d4d4d;  border-bottom: 1px solid #434343; line-height: 1.6;" v-if="parseInt(match.eventTime) <= 45">
                <div class="col" v-bind:class="{ team2: match.team == 'team2'}">
                <span >
              <span v-if="match.team == 'team1'" style="margin-right: 2px; font-weight: bold;">{{parseInt(match.eventTime.slice(0,-3))}}'</span>
              <img style="width: 24px;" src="@/assets/yellowcardBig.png" v-if="match.eventType == 'yellowcard'"/><img style="width: 24px;" src="@/assets/missed.png" v-else-if="match.eventType == 'missed_penalty'"/><img style="width: 24px;" src="@/assets/goalBig.png" v-else-if="match.eventType == 'goal' || match.eventType == 'penalty'"/><img style="width: 24px;" src="@/assets/redCardBig.png" v-else-if="match.eventType == 'redcard'"/><img style="width: 24px;" src="@/assets/yellowred.png" v-else-if="match.eventType == 'yellowred'"/><img v-else-if="match.eventType == 'var'" style="width: 24px;" src="@/assets/varCancel.png"/> <img v-else-if="match.eventType == 'own-goal'" style="width: 24px;" src="@/assets/ownGoal.png"/> <img v-else-if="match.eventType == 'substitution'" style="width: 24px;" src="@/assets/subIn.png"/> <span v-else>{{match.eventType}}</span>
              <span v-if="match.player.commonName">
               <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.player.id} }">
                 {{match.player.commonName}} 
                </router-link>
              </span>
              <span v-if="match.assistant && match.eventType == 'substitution'"> <img style="width: 24px;" src="@/assets/subOut.png"/> <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.assistant.id} }"> {{match.assistant.commonName}} </router-link> </span>
              <span v-if="match.videoPath && match.videoPath != null"><img @click="openPlayer(match.videoPath)" src="@/assets/vid.png" style="width: 24px; cursor: pointer;" alt=""></span> 
              <span v-if="match.team == 'team2'" style="margin-left: 2px; font-weight: bold;">{{parseInt(match.eventTime.slice(0,-3))}}'</span>
                  </span>
                  </div>
                <!-- <div class="col" style="text-align: right;">
                  <span v-if="match.team == 'team2'">
                    <img style="height: 15px;" src="@/assets/yellowcardBig.png" v-if="match.eventType == 'yellowcard'"/><img style="height: 15px;" src="@/assets/missed.png" v-else-if="match.eventType == 'missed_penalty'"/><img style="height: 15px;" src="@/assets/goalBig.png" v-else-if="match.eventType == 'goal' || match.eventType == 'penalty'"/><img style="height: 15px;" src="@/assets/redCardBig.png" v-else-if="match.eventType == 'redcard'"/><img style="height: 15px;" src="@/assets/yellowred.png" v-else-if="match.eventType == 'yellowred'"/><span v-else-if="match.eventType == 'var'"><img style="height: 15px;" src="@/assets/missed.png"/> <sup>var</sup></span> <span v-else-if="match.eventType == 'own-goal'"> <img style="height: 15px;" src="@/assets/goalBig.png"/> <sup style="margin-left: -7px;">OG</sup> </span><span v-else-if="match.eventType == 'substitution'"></span> <span v-else>{{match.eventType}}</span>
              <span v-if="match.player.commonName">
               <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.player.id} }">
                 {{match.player.commonName}} 
                </router-link>
              </span>
              <span v-if="match.assistant && match.eventType == 'substitution'"> <img style="height: 15px; transform: rotate(180deg);" src="@/assets/substitutionBig.png"/> <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.assistant.id} }"> {{match.assistant.commonName}} </router-link> </span>
              <span v-if="match.videoPath && match.videoPath != null"><img @click="openPlayer(match.videoPath)" src="@/assets/vid.png" style="width: 20px; cursor: pointer;" alt=""></span>  
              <span style="margin-left: 2px;">{{parseInt(match.eventTime.slice(0,-3))}}'</span>
                  </span>
                </div> -->
            </div>
            </div>
            <li class="list-group-item listHeader" style="border-radius: 0px;">{{ $t('LanguageEn.matchSet2') }}</li>
            <div class="container" v-for="match in summedArray" :key="match.kkk">
            <div class="row infoItem" style="background: #4d4d4d;  border-bottom: 1px solid #434343; line-height: 1.6;" v-if="parseInt(match.eventTime) > 45">
                <div class="col" v-bind:class="{ team2: match.team == 'team2'}">
                  <span>
              <span v-if="match.team == 'team1'" style="margin-right: 2px; font-weight: bold;">{{parseInt(match.eventTime.slice(0,-3))}}'</span>
              <img style="width: 24px;" src="@/assets/yellowcardBig.png" v-if="match.eventType == 'yellowcard'"/><img style="width: 24px;" src="@/assets/missed.png" v-else-if="match.eventType == 'missed_penalty'"/><img style="width: 24px;" src="@/assets/goalBig.png" v-else-if="match.eventType == 'goal' || match.eventType == 'penalty'"/><img style="width: 24px;" src="@/assets/redCardBig.png" v-else-if="match.eventType == 'redcard'"/><img style="width: 24px;" src="@/assets/yellowred.png" v-else-if="match.eventType == 'yellowred'"/><img v-else-if="match.eventType == 'var'" style="width: 24px;" src="@/assets/varCancel.png"/> <img v-else-if="match.eventType == 'own-goal'" style="width: 24px;" src="@/assets/ownGoal.png"/> <img v-else-if="match.eventType == 'substitution'" style="width: 24px;" src="@/assets/subIn.png"/> <span v-else>{{match.eventType}}</span>
              <span v-if="match.player.commonName">
               <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.player.id} }">
                 {{match.player.commonName}} 
                </router-link>
              </span>
              <span v-if="match.assistant && match.eventType == 'substitution'"> <img style="width: 24px;" src="@/assets/subOut.png"/> <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.assistant.id} }"> {{match.assistant.commonName}} </router-link> </span>
              <span v-if="match.videoPath && match.videoPath != null"> <img @click="openPlayer(match.videoPath)" src="@/assets/vid.png" style="width: 24px; cursor: pointer; margin-right: 2px;" alt=""></span> 
              <span v-if="match.team == 'team2'" style="margin-left: 2px; font-weight: bold;">{{parseInt(match.eventTime.slice(0,-3))}}'</span>
                  </span>
                  </div>
                <!-- <div class="col" style="text-align: right;">
                  <span v-if="match.team == 'team2'">
                    <img style="height: 15px;" src="@/assets/yellowcardBig.png" v-if="match.eventType == 'yellowcard'"/><img style="height: 15px;" src="@/assets/missed.png" v-else-if="match.eventType == 'missed_penalty'"/><img style="height: 15px;" src="@/assets/goalBig.png" v-else-if="match.eventType == 'goal' || match.eventType == 'penalty'"/><img style="height: 15px;" src="@/assets/redCardBig.png" v-else-if="match.eventType == 'redcard'"/><img style="height: 15px;" src="@/assets/yellowred.png" v-else-if="match.eventType == 'yellowred'"/><span v-else-if="match.eventType == 'var'"><img style="height: 15px;" src="@/assets/missed.png"/> <sup>var</sup></span> <span v-else-if="match.eventType == 'own-goal'"> <img style="height: 15px;" src="@/assets/goalBig.png"/> <sup style="margin-left: -7px;">OG</sup> </span><span v-else-if="match.eventType == 'substitution'"></span> <span v-else>{{match.eventType}}</span>
              <span v-if="match.player.commonName">
               <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.player.id} }">
                 {{match.player.commonName}} 
                </router-link>
              </span>
              <span v-if="match.assistant && match.eventType == 'substitution'"> <img style="height: 15px; transform: rotate(180deg);" src="@/assets/substitutionBig.png"/> <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: match.assistant.id} }"> {{match.assistant.commonName}} </router-link> </span>
              <span v-if="match.videoPath && match.videoPath != null"><img @click="openPlayer(match.videoPath)" src="@/assets/vid.png" style="width: 20px; cursor: pointer;" alt=""></span>  
              <span style="margin-right: 2px;">{{parseInt(match.eventTime.slice(0,-3))}}'</span>
                  </span>
                </div> -->
            </div>
            </div>
            <div v-if="MatchStats.match.referee && MatchStats.match.venue">
            <li class="list-group-item listHeader" style="border-radius: 0px;">{{ $t('LanguageEn.txtReferee') }} / {{ $t('LanguageEn.txtStadium') }}</li>
            <li class="list-group-item referee" v-if="MatchStats.match.referee.name">{{ $t('LanguageEn.txtReferee') }}: {{MatchStats.match.referee.name}}</li>
            <li class="list-group-item referee" v-if="MatchStats.match.venue.name">{{ $t('LanguageEn.txtStadium') }}: {{MatchStats.match.venue.name}}</li> 
            <li class="list-group-item referee" v-if="MatchStats.match.tvStations.length != 0"> Broadcasted: <span v-if="MatchStats.match.tvStations[0]">{{MatchStats.match.tvStations[0]}},</span> <span v-if="MatchStats.match.tvStations[1]">{{MatchStats.match.tvStations[1]}},</span> <span @click="$refs['tv-modal'].show()" style="text-decoration: underline; cursor: pointer; color: #1a7bfb;"> More</span> </li> 
            </div>
            </div>
    </div>
    </b-tab>
    <b-tab lazy>
      <template v-slot:title>
        <img style="width: 23px" src="@/assets/matchpageNavbar/lineUps.png"><br><p style="margin: 0px; color: #333333; font-size: 12px;">{{ $t('LanguageEn.txtLineUp') }}</p>
      </template>
      <div>
           <ul class="list-group Info">
            <div v-if="MatchStats.match.lineups[0]">
            <li class="list-group-item listHeader" style="border-radius: 0px;">{{ $t('LanguageEn.txtFormations') }}</li>
            <li class="list-group-item infoItemHead">
              <div class="row">
                <div class="col-9">
              {{MatchStats.match.lineups[0].team.name}} 
              </div>
                <div class="col" style="text-align: center;">
              {{MatchStats.match.team1Formation}}
                </div>
              </div>
              </li>
            <li class="list-group-item infoItem" v-for="lineup in MatchStats.match.lineups[0].players" :key="lineup.idd">
              <div class="row">
                <div class="col-10">
               <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: lineup.player.id} }">
              {{lineup.player.commonName}}
               </router-link>
              </div>
                <div class="col" style="text-align: center;">
              {{lineup.shirtNumber}}
                </div>
              </div>
              </li>
            </div>
            <div v-if="MatchStats.match.lineups[1]">
               <li class="list-group-item infoItemHead">
              <div class="row">
                <div class="col-9">
              {{MatchStats.match.lineups[1].team.name}} 
              </div>
                <div class="col" style="text-align: center;">
              {{MatchStats.match.team2Formation}}
                </div>
              </div>
              </li>
            <li class="list-group-item infoItem" v-for="lineup in MatchStats.match.lineups[1].players" :key="lineup.idk" style="border-radius: 0px;">
              <div class="row">
                <div class="col-10">
              <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: lineup.player.id} }">
              {{lineup.player.commonName}}
               </router-link>
              </div>
                <div class="col" style="text-align: center;">
              {{lineup.shirtNumber}}
                </div>
              </div>
              </li>
            </div>
            <div v-else>
            <li class="list-group-item listHeader" style="border-radius: 0px;">There is no data at the moment!</li>
            </div>
          </ul>  
            </div>
    </b-tab>
    <b-tab lazy>
      <template v-slot:title>
        <img style="height: 22px" src="@/assets/matchpageNavbar/statistics.png"><br><p style="margin: 0px; color: #333333; font-size: 12px;">{{ $t('LanguageEn.txtStatistics') }}</p>
      </template>
      <li class="list-group-item listHeader" style="border-radius: 0px;" v-if="MatchStats.match.statistics.length == 0">There is no data at the moment!</li>
     <div v-for="stat in MatchStats.match.statistics" :key="stat.id" v-else>
    <li class="list-group-item listHeader" style="border-radius: 0px;">
      <p style="height: 0px;" v-if="stat.statisticKey == 'attacks'"> {{ $t('LanguageEn.statisticAttacks') }} </p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'ball_safe'"> {{ $t('LanguageEn.statisticBallSafe') }} </p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'corners'"> {{ $t('LanguageEn.statisticCorners') }} </p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'dangerous_attacks'"> {{ $t('LanguageEn.statisticDangerousAttacks') }} </p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'fouls'"> {{ $t('LanguageEn.statisticFouls') }} </p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'goals'"> {{ $t('LanguageEn.statisticGoals') }} </p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'goal_attempts'"> {{ $t('LanguageEn.statisticGoalAttempts') }} </p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'injuries'"> {{ $t('LanguageEn.statisticInjuries') }} </p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'offsides'"> {{ $t('LanguageEn.statisticOffsides') }} </p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'passes_accurate'">{{ $t('LanguageEn.statisticPassesAccurate') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'passes_percentage'">{{ $t('LanguageEn.statisticPassesPercentage') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'passes_total'">{{ $t('LanguageEn.statisticPassesTotal') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'penalties'">{{ $t('LanguageEn.statisticPenalties') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'possession_time'">{{ $t('LanguageEn.statisticPossessionTime') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'red_cards'">{{ $t('LanguageEn.statisticRedCards') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'saves'">{{ $t('LanguageEn.statisticSaves') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'shots_blocked'">{{ $t('LanguageEn.statisticShotsBlocked') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'shots_insidebox'">{{ $t('LanguageEn.statisticShotsInsidebox') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'shots_offgoal'">{{ $t('LanguageEn.statisticShotsOffGoal') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'shots_ongoal'">{{ $t('LanguageEn.statisticShotsOnGoal') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'shots_outsidebox'">{{ $t('LanguageEn.statisticShotsOutsidebox') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'shots_total'">{{ $t('LanguageEn.statisticShotsTotal') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'substitutions'">{{ $t('LanguageEn.statisticSubstitution') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'yellow_cards'">{{ $t('LanguageEn.statisticYellowCard') }}</p>
      <p style="height: 0px;" v-else-if="stat.statisticKey == 'yellow_red_cards'">{{ $t('LanguageEn.statisticYellowRedCards') }}</p>
      <p style="height: 0px;" v-else>{{ $t('LanguageEn.statisticElse') }}</p>
      </li>
    <li class="list-group-item infoItem">
    <b-progress class="" :max="max" show-value>
      <b-progress-bar style="font-weight: 800px; background: green !important;" :value="stat.team1Value / (stat.team1Value + stat.team2Value) * 100" variant="success">{{stat.team1Value}}</b-progress-bar>
      <b-progress-bar style="font-weight: 800px; background: #ffbf00 !important; color: black;" :value="stat.team2Value / (stat.team1Value + stat.team2Value) * 100">{{stat.team2Value}}</b-progress-bar>
    </b-progress>
    </li>
  </div>
    </b-tab>
    <b-tab style="border-radius: 0px; background: #212529" lazy>
      <template v-slot:title>
        <img style="height: 22px" src="@/assets/matchpageNavbar/table.png"><br> <p style="margin: 0px; color: #333333; font-size: 12px;">{{ $t('LanguageEn.txtTable') }}</p>
      </template>
          <div>
        <li class="list-group-item listHeader" style="border-radius: 0px;" v-if="leagueTable.length == 0">There is no data at the moment!</li>
        <ul class="list-group" v-else>
        <li class="list-group-item MobileHide" style="color: white; background: #39b54a; border-radius: 0px;">
            <div class="row">
            <div class="col">
                #
            </div>
            <div class="col-6">
                {{ $t('LanguageEn.txtTeam') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableCount') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableWin') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableDraw') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableLose') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableGoals') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTablePoint') }}
            </div>
        </div>
        </li>
        <li class="list-group-item MobileShow Some" style="color: white; background: #39b54a;">
              <div class="row">
            <div class="col pr-1">
                #
            </div>
             <div class="col">
                F
            </div>
            <div class="col-2 pl-1">
                {{ $t('LanguageEn.txtTeam') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableCount') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableWin') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableDraw') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableLose') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableGoals') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTablePoint') }}
            </div>
        </div>
        </li>
        <div v-for="table in standings" :key="table.idll" class="MobileHide">
          <div v-for="(group, i) in table" :key="group.id" class="MobileHide">
        <li class="list-group-item header MobileHide" style="background: #4d4d4d; margin-top: 0px; margin-bottom: 0px; color: white; text-align: center; line-height: 5px;" v-if="i < 1 && group.groupName">{{group.groupName}}</li>
        <li style="height: 35px; border: none; font-size: 14px" class="list-group-item" v-bind:class="{blackBg: group.position % 2 == 0, yellowBg: group.team.name == team1name || group.team.name == team2name}">
            <router-link style="text-decoration: none;" id="router-link" :to="{ name: 'teamPage', params: { id: group.team.id, name: group.team.name } }"><div class="row">
                <div class="col" style="color: #333333;">
                    {{group.position}}
                </div>
                <div class="col-6" style="color: #333333;">
                    {{group.team.name}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.gameCount}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.win}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.draw}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.lose}}
                </div>
                <div class="col" style="color: #333333; text-align: center;">
                    {{group.goalScored - group.goalAgainst}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.points}}
                </div>
            </div></router-link>
        </li>
        </div>
        </div>
        <div v-for="table in standings" :key="table.idll" class="MobileShow">
          <div v-for="(group, i) in table" :key="group.id" class="MobileShow">
        <li class="list-group-item header MobileShow" style="background: #4d4d4d; margin-top: 0px; margin-bottom: 0px; color: white; text-align: center; line-height: 5px;" v-if="i < 1 && group.groupName">{{group.groupName}}</li>
        <li style="height: 35px; border: none; font-size: 14px" class="list-group-item" v-bind:class="{blackBg: group.position % 2 == 0, yellowBg: group.team.name == team1name || group.team.name == team2name}">
           <router-link style="text-decoration: none;" id="router-link" :to="{ name: 'teamPagePar', params: { id: group.team.id } }"><div class="row">
                <div class="col pr-1" style="color: #333333;">
                    {{group.position}}
                </div>
                <div class="col" style="color: #333333;">
                     <img :src="teamLogo + group.team.id" alt="" style="width: 17px;" >
                </div>
                <div class="col-2 pl-1" style="color: #333333; font-size: 13px; margin-top: 3px;" v-if="group.team.shortCode">
                    {{group.team.shortCode}}
                </div>
                <div class="col-2 pl-1" style="color: #333333; font-size: 13px;" v-else>
                    {{group.team.name.slice(0,3)}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.gameCount}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.win}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.draw}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.lose}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.goalScored - group.goalAgainst}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.points}}
                </div>
            </div></router-link>
        </li>
        </div>
        </div>
        </ul>
    </div>
    </b-tab>
    <b-tab style="border-radius: 0px; background: #212529" lazy>
      <template v-slot:title>
        <img style="height: 22px" src="@/assets/matchpageNavbar/h2h.png"><br><p style="margin: 0px; color: #333333; font-size: 12px;">H2H</p>
      </template>
          <div>
       <div v-for="game in gamesTween.matches" :key="game.idq">
            <ul class="list-group Info" style="border-radius: 0px;" v-if="game.matchStatus.name != 'NS'">
             <li class="list-group-item listHeader MobileHide" style="text-align: end;line-height: 5px">{{game.matchTime.slice(0,-9)}}</li>
               <li v-on:click="id = game.id, emitToParent()" class="list-group-item infoItem MobileHide" style="cursor: pointer;">
                <div class="row" style="height: 40px;">
                    <div class="col">
                    <div class="circle"></div>
                </div>
                    <div class="col-5">
                        <p>{{game.team1.name}} </p>
                        <p>{{game.team2.name}}</p>   
                    </div>
                    <div class="col-3">
                    </div>
                    <div class="col-1">
                       <p>{{game.currentScore.slice(0,1)}}</p>
                       <p>{{game.currentScore.slice(-1)}}</p>
                    </div>
                     <div class="col">
                        <div class="circle"> 
                        <p style="text-align: center; padding-top: 30%;" v-if="game.matchStatus.name == 'CANCL'">CNL</p>
                        <p style="text-align: center; padding-top: 30%;" v-else-if="game.matchStatus.name == 'POSTP'">POS</p>
                        <p style="text-align: center; padding-top: 30%;" v-else>{{game.matchStatus.name}}</p>
                        </div> 
                     </div>
                    </div>  
                </li>
                <li class="list-group-item listHeader MobileShow Some" style="text-align: end; line-height: 12px;">{{game.matchTime.slice(0,-9)}}</li>
             <li v-on:click="id = game.id, emitToParent()" class="list-group-item infoItem MobileShow Some" style="line-height: 5px;">
                <div class="row">
                    <div class="col-1" style="margin-top: 3px; margin-right: 20px;">
                    <div class="circle">                     
                    </div>
                </div>
                    <div class="col-7" style="margin-top: 7px; text-align: left;">
                        <p v-if="game.team1.name.length > 16">{{game.team1.name.slice(0,15)}}.. </p><p v-else>{{game.team1.name}} </p>
                        <p v-if="game.team2.name.length > 16">{{game.team2.name.slice(0,15)}}.. </p><p v-else>{{game.team2.name}} </p>
                    </div>
                    <div class="col-1" style="margin-top: 7px;">
                       <p>{{game.currentScore.slice(0,1)}}</p>
                       <p>{{game.currentScore.slice(-1)}}</p>
                    </div>
                     <div class="col-1" style="margin-top: 3px; margin-right: 20px;">
                        <div class="circle"> 
                        <p style="text-align: center; padding-top: 40%;" v-if="game.matchStatus.name == 'CANCL'">CNL</p>
                        <p style="text-align: center; padding-top: 40%;" v-else-if="game.matchStatus.name == 'POSTP'">POS</p>
                        <p style="text-align: center; padding-top: 40%;" v-else>{{game.matchStatus.name}}</p>
                        </div> 
                     </div>
                    </div>  
                </li>
             </ul>  
          </div>
    </div>
    </b-tab>
    <b-tab style="border-radius: 0px; background: #212529" lazy>
      <template v-slot:title>
        <img style="height: 22px" src="@/assets/comments.png"><br><p style="margin: 0px; color: #333333; font-size: 12px;">{{ $t('LanguageEn.comments') }}</p>
      </template>
        <div>
          <div>
            <b-overlay no-center :show="Overlay" variant="light" opacity="0.6" style="">
            <!-- <p v-if="MatchStats.match.commentaries.length != 0" style="text-align: right; line-height: 1.5;">
            <span style="color: white"> Translate: </span>
            <span style="color: white" v-for="(lang, i) in languages" :key="lang.id" @click="translate(lang.id)" >{{lang.name}} <span v-if=" i + 1 < languages.length">, </span></span>
            </p> -->
            <li class="list-group-item listHeader" style="border-radius: 0px; text-align: left;" v-if="MatchStats.match.commentaries.length != 0">
              <span>Language: </span>
              <span v-for="(lang, i) in languages" :key="lang.id" @click="translate(lang.id), ss = lang.id" style="cursor: pointer;" v-bind:class="{slang: lang.id == ss}">
              {{lang.name}} <span v-if=" i + 1 < languages.length">, </span> 
              </span>
              </li>
            <li class="list-group-item listHeader" style="border-radius: 0px;" v-if=" MatchStats.match.commentaries.length == 0">There is no data at the moment!</li>
            <li  class="list-group-item infoItem" v-for="(comment, indx) in comms" :key="comment.id" v-bind:class="{rbg: indx % 2 == 0}">
              <span v-bind:class="{import: comment.important == 1}">
              <div class="row"> 
              <span class="col-1" v-if="comment.minute > 9">{{comment.minute}}'</span> 
              <span class="col-1" v-else>0{{comment.minute}}'</span> 
              <span class="col" style="margin-left: 5px; line-height: 1.3;"><img style="width: 15px;" src="@/assets/goalBig.png" v-if="comment.goal == 1"/>  {{comment.comment}}</span>  
              </div>
              </span>
            </li>
            </b-overlay>
          </div>
        </div>
    </b-tab>
    <b-tab style="border-radius: 0px; background: rgb(255,255,255)" lazy>
      <template v-slot:title>
        <img style="height: 22px" src="@/assets/game.png"><br><p style="margin: 0px; color: #333333; font-size: 12px;">Guess</p>
      </template>
        <div class="predict" v-if="MatchStats.match.matchStatus.name == 'NS' && pred.gamePredictions.length == 0">
          <div class="row" >
            <div class="col" style="margin-top: 15px; margin-bottom: 10px; text-align: right;">
             <div class="row">
              <p style="font-weight: 600; margin-top: 30px; color: white;" class="col">{{team1name}}</p>
              <b-form-spinbutton class="" id="sb-vertical" size="lg" min="0" max="20" wrap v-model="team1score" vertical style="background: rgba(40,167,69, 0.8); border: none; color: white; margin-right: 5px;"></b-form-spinbutton>
            </div>
            </div>
            <div class="col" style="margin-top: 15px; margin-bottom: 10px;">
              <div class="row">
              <p style="margin-top: 30px; color: white;">:</p>
              <b-form-spinbutton class="" id="sb-vertical2" size="lg" min="0" max="20" wrap v-model="team2score" vertical style="background: rgba(40,167,69, 0.8); border: none; color: white; margin-left: 5px;"></b-form-spinbutton>
              <p style="font-weight: 600;  margin-top: 30px; color: white;" class="col">{{team2name}}</p>
            </div>
            </div>
          </div>
          <div style="padding-top: 10px; padding-bottom: 10px; text-align: center;">
            <b-btn variant="success" style="width: 160px; background: rgba(40,167,69, 0.8); border: none;" @click="$refs['sure-modal'].show()">Guess</b-btn>
          </div>
        </div>
        <div class="predict" v-else-if="MatchStats.match.matchStatus.name == 'NS' && pred.gamePredictions.length != 0">
          <div class="row" >
            <div class="col " style="margin-top: 15px; margin-bottom: 10px; text-align: right; font-size: 18px;">
             <div class="row">
              <p style="font-weight: 600; margin-top: 20px; color: white;" class="col">{{team1name}}</p>
            </div>
            </div>
            <div class="col " style="text-align: center; margin-top: 15px; margin-bottom: 10px; font-size: 18px;">
              <p style="font-weight: 600;  margin-top: 20px; color: white;" class="col">{{pred.gamePredictions[0].predictionValue}}</p>
            </div>
            <div class="col " style="margin-top: 15px; margin-bottom: 10px; font-size: 18px;">
              <div class="row">
              <p style="font-weight: 600;  margin-top: 20px; color: white;" class="col">{{team2name}}</p>
            </div>
            </div>
          </div>
          <div v-if="pred.gamePredictions[0].calculation != null" style="text-align: center; color: white;">
            <ul style="list-style-type: none; padding-left: 0px;">
              <li class="row container"><span class="col pl-5" style="text-align: right;"> bonus: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.bonus}}</span></li>
              <li class="row container"><span class="col pl-5" style="text-align: right;"> result: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.result}}</span></li>
              <li class="row container"><span class="col pl-5" style="text-align: right;"> match score: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.matchScore}}</span></li>
              <li class="row container"><span class="col pl-5" style="text-align: right;"> total goals: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.totalGoals}}</span></li>
              <li class="row container"><span class="col pl-5" style="text-align: right;"> Scored by away: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.goalsScoredByAway}}</span></li>
              <li class="row container"><span class="col pl-5" style="text-align: right;"> Scored by home: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.goalsScoredByHome}}</span></li>
            </ul>
          </div>
          <div style="padding-top: 10px; padding-bottom: 10px; text-align: center;">
            <b-btn variant="success" style="width: 160px; background: rgba(227, 10, 23, 0.8); border: none;" @click="$refs['remove-modal'].show()">REMOVE</b-btn>
          </div>
        </div>
        <div class="predict" v-else-if="MatchStats.match.matchStatus.name == 'FT' && pred.gamePredictions.length != 0 || MatchStats.match.matchStatus.name == 'AET' && pred.gamePredictions.length != 0">
          <div style="padding-top: 10px; padding-bottom: 10px; text-align: center;">
            <b-btn variant="success" style="width: 160px; background: rgba(227, 10, 23, 0.8); border: none;" disabled>FINISHED</b-btn>
          </div>
          <div class="row" >
            <div class="col " style="margin-bottom: 10px; text-align: right;">
             <div class="row">
              <p style="font-weight: 600;  color: white;" class="col">{{team1name}}</p>
            </div>
            </div>
            <div class="col " style="text-align: center;  margin-bottom: 10px; ">
              <p style="font-weight: 600;  color: white;" class="col">{{pred.gamePredictions[0].predictionValue}}</p>
            </div>
            <div class="col " style=" margin-bottom: 10px; ">
              <div class="row">
              <p style="font-weight: 600;   color: white;" class="col">{{team2name}}</p>
            </div>
            </div>
          </div>
          <div v-if="pred.gamePredictions[0].calculation != null" style="text-align: center; color: white; padding-bottom: 10px;">
            <ul style="list-style-type: none; padding-left: 0px;">
              <li class="row container"><span class="col pl-5" style="text-align: right;"> bonus: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.bonus}}</span></li>
              <li class="row container"><span class="col pl-5" style="text-align: right;"> result: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.result}}</span></li>
              <li class="row container"><span class="col pl-5" style="text-align: right;"> match score: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.matchScore}}</span></li>
              <li class="row container"><span class="col pl-5" style="text-align: right;"> total goals: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.totalGoals}}</span></li>
              <li class="row container"><span class="col pl-5" style="text-align: right;"> Scored by away: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.goalsScoredByAway}}</span></li>
              <li class="row container"><span class="col pl-5" style="text-align: right;"> Scored by home: </span> <span class="col" style="text-align: left;">{{pred.gamePredictions[0].calculation.goalsScoredByHome}}</span></li>
            </ul>
          </div>
        </div>
        <div v-else>
        <li class="list-group-item listHeader" style="border-radius: 0px;">You can only Predict for not started games!</li>
        </div>
    </b-tab>
  </b-tabs>
</div>


<b-modal ref="sure-modal" size="md" hide-footer centered hide-header>
        <p style="text-align: center;">Your prediction is: <br> {{team1name}} {{team1score}} - {{team2score}} {{team2name}}</p>
        <b-row>
        <b-col style="text-align: left;">
            <b-button type="submit" class=""  variant="outline-danger" style="" @click="$refs['sure-modal'].hide()">CANCEL</b-button>
        </b-col>
        <b-col style="text-align: right;">
            <b-button  type="submit" class="" variant="outline-success" @click="guessScore(), $refs['sure-modal'].hide()">SUBMIT</b-button>
        </b-col>
        </b-row>
    </b-modal>
    <b-modal ref="remove-modal" size="md"  hide-footer centered hide-header>
        <p style="text-align: center;">By removing this prediction, you will gain only 80% of points back. Are you sure? </p>
        <b-row>
        <b-col style="text-align: left;">
            <b-button type="submit" class=""  variant="outline-danger" style="" @click="$refs['remove-modal'].hide()">CANCEL</b-button>
        </b-col>
        <b-col style="text-align: right;">
            <b-button  type="submit" class="" variant="outline-success" @click="deletePred(pred.gamePredictions[0].id), $refs['remove-modal'].hide()">REMOVE</b-button>
        </b-col>
        </b-row>
    </b-modal>
    <div style="position: fixed; bottom: 40px; right: 20px;  z-index: 1; cursor: pointer;">
      <p style="background: none;" v-if="ppp > 1200" @click="scrollToTop()"><img src="@/assets/upp.png" style="background: none; width: 50px;" alt=""></p>
    </div>
  
  </div> 
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'MatchPage',
  data(){
      return{
          MatchStats: [],
          leagueTable: [],
          gamesTween: [],
          gameId: '',
          teamLogo: 'https://sportapi.zuniac.com/team/logo/',
          leagueId: '',
          team1name:'',
          team2name:'',
          teamID:'',
          id : '',
          cookiesObject: '',
          max: 100,
          newArray1: [],
          newArray2: [],
          summedArray: [],
          standings: [],
          tournId: '',
          team1score: 0,
          team2score: 0,
          ppp:'',
          comms: '',
          languages: '',
          ss:'1',
          pred: '',
          Overlay: false,
      }
  },
  async mounted(){
    this.id = this.$route.params.gameId;
    
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    window.addEventListener("scroll", this.onScroll);

    this.langList();

    this.gamePr();

    this.getData();


    setInterval(() => {
        this.getData();
    }, 50000);
  },
  components: {
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    clearInterval(this.setInterval);
  },
  methods : {
   async getData(){
      var offset = new Date().getTimezoneOffset();

    if (this.cookiesObject.token) {
    var res = await fetch(this.httpReq + '/match?matchId='+ this.id +'&portalId=' + this.cookiesObject.portalId + '&timezone=%2B'+ offset/-60 +'%3A00&token=' + this.cookiesObject.token );
    var data = await res.json();
    var MatchStats = data;
    this.MatchStats = MatchStats;
    this.comms = MatchStats.match.commentaries;
    this.tournId =  MatchStats.match.tournament.id;
    this.team1name =  MatchStats.match.team1.name;
    this.team2name =  MatchStats.match.team2.name;
    
    if (data.code == 200) {
       //everything is okay
    } else if (data.code == 401) {
      alert('Logged from another browser, try to re sign!');
      document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }else if (data.code == 404) {
      alert('you dont have access to this match')
      document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else{
     alert('server error')
     document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }
    
    } else {
    var resp = await fetch(this.httpReq + '/match?matchId='+ this.id +'&portalId=' + this.cookiesObject.portalId + '&timezone=%2B'+ offset/-60 +'%3A00');
    var datas = await resp.json();
    var MatchStatss = datas;
    this.MatchStats = MatchStatss;
    this.tournId =  MatchStatss.match.tournament.id;
    }
    
    const res1 = await fetch(this.httpReq + '/standings?portalId=' + this.cookiesObject.portalId +'&token='+ this.cookiesObject.token + '&tournamentId='+this.MatchStats.match.tournament.id);
     const data1 = await res1.json();
    //  const leagueTable = data1;
     this.leagueTable = data1.standings;

     const res2 = await fetch(this.httpReq + '/match/h2h?matchId='+ this.id +'&portalId=' + this.cookiesObject.portalId + '&timezone=%2B'+ offset/-60 +'%3A00');
     const data2 = await res2.json();
     const gamesTween = data2;
     this.gamesTween = gamesTween;

     this.standings = this.groupBy(this.leagueTable, 'groupName');
     
    this.newArray1 = MatchStats.match.events[0].events.map(function(el){
      var o = Object.assign({},el);
      o.team = 'team1';
      return o;
    });

    this.newArray2 = MatchStats.match.events[1].events.map(function(el){
      var o = Object.assign({},el);
      o.team = 'team2';
      return o;
    });

    this.summedArray = this.newArray1.concat(this.newArray2);

    this.summedArray.sort(function(a, b){return parseInt(a.eventTime) - parseInt(b.eventTime)});

    this.$forceUpdate();

    },
    deletePred(val){
        var myHeaders = new Headers();
            myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

            var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            redirect: 'follow'
            };

            fetch(this.httpReq+'/game/prediction?token='+ this.cookiesObject.token +'&predictionId='+val, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result.message);
                this.gamePr();
                this.$forceUpdate(); 
                })
            .catch(error => console.log('error', error));
    },
    async langList(){
      const res = await fetch(this.httpReq +'/general/appData?portalId=' + this.cookiesObject.portalId, {method: 'get'});
      const data = await res.json();
      const languages = data.portal.languages;
      this.languages = languages;
    },
     onScroll(e) {
      this.ppp = e.target.documentElement.scrollTop;
    },
    scrollToTop() {
      window.scrollTo(0,250);
    },
    gamePr(){
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.httpReq + "/game/predictions?matchId="+ this.id +"&timezone=%2B04%3A00&token=" + this.cookiesObject.token, requestOptions)
        .then(response => response.json())
        .then(result => {
          this.pred = result;
          console.log(result.gamePredictions)
          })
        .catch(error => console.log('error', error));
    },
    translate(val){
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.httpReq + "/match/commentaries/translate?languageId="+ val +"&matchId="+ this.id +"&token=" + this.cookiesObject.token, requestOptions)
        .then(response => response.json())
        .then( this.Overlay = true )
        .then(result => {
          this.comms = result.commentaries;
          this.$forceUpdate();
          })
        .then(result => {
          console.log(result);
          this.Overlay = false;
        })
        .catch(error => console.log('error', error));
    },
    goto(){
      this.$router.push({name: 'PredictionsList', params: { } })
    },
    guessScore(){
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.httpReq + '/game/prediction?matchId='+ this.id +'&predictionValue='+ this.team1score +'-'+ this.team2score +'&timezone=%2B04%3A00&token=' + this.cookiesObject.token, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.code == 200) {
                this.gamePr();
                this.$forceUpdate(); 
            } else {
              alert(result.message)
            }
          })
        .catch(error => console.log('error', error));
    },
    openPlayer(val){
        window.open(val, 'newwin', 'height=600px, width=900px');
    },
    emitToParent(){
      this.$emit('childToParent', this.id)    
      },
      groupBy(objectArray, property) {
      return objectArray.reduce((acc, obj) => {
          const key = obj[property];
          if (!acc[key]) {
            acc[key] = [];
          }
          // Add object to list for given key's value
          acc[key].push(obj);
          return acc;
      }, {});
},

calculateMinutes(value){
        if (value == null) {
            return 'LIVE';
        } else{

        var startDate = new Date(value.replace(' ', 'T'));
        var endDate   =  Date.now();
        var difference = ((endDate - startDate) / 1000) / 60;

        if (difference < 0) {
            difference = difference + 240;
        }

        return parseInt(difference);
        }
         },
  },
  computed:{
       ...mapGetters(['httpReq']),
  },
}

</script>

<style scoped>
.slang{
  color: #009246;
  font-weight: 550;
}
.rbg{
  background: #5e5c5c !important;
}
.import{
  font-weight: bold;
}

.team2{
  text-align: right;
  margin-right: 0px;
}
.blackBg{
    background: #e6e6e6;

}
.predict{
   background:linear-gradient(
          rgba(0, 0, 0, 0.7), 
          rgba(0, 0, 0, 0)
        ),
  url('9.jpg');
  background-size:cover;
}
.yellowBg{
  background: #d8c866 !important;
}
 
.Loc{
    background:linear-gradient(
          rgba(0, 0, 0, 0.4), 
          rgba(0, 0, 0, 0.4)
        ),  url('../Teampage/soccerCover.jpg');
    background-size: cover;
    width: 100%;
    height: 300px;
    margin-top: -17px;
}
.circle {
    background: #333333;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.leagueNam{
    text-align:center; 
    padding-top: 70px;
    font-size: 18px;
    color: white;
}


/* Navbar (info, H2H, etc.) */


.navDiv2{
    width: 100%;
    height: 60px;
    color: white;
    background-image: linear-gradient(#fefefe , #c3c3c3);  
}

#topheader2 .navbar-nav li > a {
	text-transform: capitalize;
    transition: background-color 0.2s, color 0.2s;
}

    #topheader2 .navbar-nav li > a:focus {
        background-image: linear-gradient(#39b44a , #39b54a);
        color: #fff !important;
	}

#topheader2 .navbar-nav li.active > a {
	background-color: #333;
	color: #fff;
}

#routerLink{
  padding-top: 10%;
    display: inline-block; 
    text-decoration: none;
    width: 111px !important;
    height: 60px !important;
    color: black !important;
    text-align: center !important;
    margin-top: -8px;
}
#routerLink .navbar-nav li > a {
	text-transform: capitalize;
	transition: background-color 0.2s, color 0.2s;
    
}

    #routerLink .navbar-nav li > a:focus {
        background-image: linear-gradient(#39b44a , #1b5f20);
		color: #fff !important;
	}

#routerLink .navbar-nav li.active > a {
	background-color: #333;
	color: #fff;
}

.Info{
    width: 100%;
}

.list-group-item{
    line-height: 15px;
}

.listHeader{
  background-color: #333333 !important;  
  color: white;
  text-align: center;
  font-weight: 400;
  font-size: 15px;
}

.infoItem{
background-color: #4d4d4d;
color: white;
/* border-color: #333333 !important;
border-width: 1px !important; */
}

/* bottom of the page info css (referee, stadium) */

.referee{
background-color: #4d4d4d !important;
color: white;
border: none;
}


@media only screen and (max-width: 600px) {
  body{
    background: #212529;
  }
  .Loc{
    background-image: url("https://zunisport.com/style/path/img/soccer-cover.jpg");
    background-size: cover ;
    width: 100% !important;
}

.blackBg{
  background: #e6e6e6;
}
  .navDiv2{
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;  
}
.leagueNam{
    text-align:center; 
    padding-top: 20px;
    font-size: 15px;;
    color: white;
  justify-content: center;
  }

  .MobileHide {
    display: none;
  }
}

@media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
<style>
  .bi-plus{
    fill: white;
  }
   .bi-dash{
    fill: white;
  }
  .spinner-border{
    display:table;
    margin: 0 auto;
    margin-top: 20px;
    color: green;
  }

  @media only screen and (max-width: 770px) {
  .nav-tabs {
flex-wrap: nowrap;
white-space: nowrap;
max-width: 770px;
overflow: auto;
}
}
</style>
